import { cn } from '@/lib/utils';

import { AdditionalSVGProps } from '@/models/Svg';

export const YouTubeIcon = (
  props: React.SVGAttributes<SVGElement> & AdditionalSVGProps,
) => {
  const { className, fill = '#010f1d', ...rest } = props;

  return (
    <>
      <svg
        width='29'
        height='29'
        viewBox='0 0 29 29'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={cn(`fill-[${fill}]`, className)}
        {...rest}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M15.9974 0.333252C17.3511 0.333252 18.7397 0.368085 20.0856 0.425085L21.6752 0.501085L23.1968 0.591335L24.6218 0.687919L25.9233 0.789252C27.3357 0.897358 28.6648 1.50008 29.6766 2.4914C30.6885 3.48271 31.3184 4.79911 31.4555 6.209L31.5188 6.88192L31.6376 8.32275C31.7484 9.81583 31.8307 11.4435 31.8307 12.9999C31.8307 14.5563 31.7484 16.184 31.6376 17.6771L31.5188 19.1179C31.4982 19.3491 31.4776 19.5723 31.4555 19.7908C31.3183 21.201 30.6882 22.5176 29.676 23.5089C28.6638 24.5003 27.3344 25.1028 25.9217 25.2106L24.6234 25.3103L23.1984 25.4085L21.6752 25.4988L20.0856 25.5748C18.7236 25.6339 17.3606 25.6646 15.9974 25.6666C14.6342 25.6646 13.2712 25.6339 11.9092 25.5748L10.3196 25.4988L8.79798 25.4085L7.37298 25.3103L6.07148 25.2106C4.65907 25.1025 3.33002 24.4998 2.31814 23.5084C1.30627 22.5171 0.676388 21.2007 0.539312 19.7908L0.475979 19.1179L0.357229 17.6771C0.236164 16.1209 0.171732 14.5608 0.164062 12.9999C0.164062 11.4435 0.246396 9.81583 0.357229 8.32275L0.475979 6.88192C0.496563 6.65075 0.517146 6.4275 0.539312 6.209C0.676335 4.79936 1.30599 3.48316 2.31754 2.49188C3.32909 1.5006 4.65777 0.897714 6.0699 0.789252L7.36981 0.687919L8.79481 0.591335L10.318 0.501085L11.9076 0.425085C13.2701 0.365921 14.6337 0.335303 15.9974 0.333252ZM12.8307 9.16034V16.8395C12.8307 17.571 13.6224 18.027 14.2557 17.6628L20.9057 13.8233C21.0504 13.74 21.1706 13.62 21.2542 13.4754C21.3378 13.3309 21.3818 13.1669 21.3818 12.9999C21.3818 12.833 21.3378 12.6689 21.2542 12.5244C21.1706 12.3798 21.0504 12.2599 20.9057 12.1766L14.2557 8.33859C14.1113 8.25518 13.9474 8.21128 13.7806 8.21131C13.6138 8.21134 13.4499 8.25529 13.3055 8.33874C13.161 8.42219 13.0411 8.5422 12.9578 8.68671C12.8744 8.83121 12.8306 8.99511 12.8307 9.16192V9.16034Z'
        />
      </svg>
    </>
  );
};
